export default __webpack_public_path__ + "static/media/img_goods2.8b6e5191.svg";